import type { SurfaceProps } from './types';
import { surfaceFilled } from './types';

/**
 * Тест-кейс по структуре IEEE 829 (строгая форма).
 * Поля: ID · Заголовок · Предусловие · Шаги · Ожидаемый результат · Постусловие.
 * Обязательны для гейта: заголовок, предусловие, шаги, ожидаемый результат.
 */
export function TestCaseForm({ spec, value, disabled, onChange }: SurfaceProps) {
  const v: Record<string, string> = {
    tcId: '', title: '', precondition: '', steps: '', expected: '', postcondition: '',
    ...(value as Record<string, string> | undefined),
  };
  const set = (patch: Record<string, string>) => {
    const next = { ...v, ...patch };
    onChange(next, surfaceFilled(spec, next));
  };

  return (
    <div className="surf surf-tc" data-testid="surf-testcase">
      <div className="surf-tag">Тест-кейс · IEEE 829</div>
      <label className="bug-field">
        <span className="l">ID</span>
        <input value={v.tcId} disabled={disabled} placeholder="TC-01"
          data-testid="tc-id" onChange={(e) => set({ tcId: e.target.value })} />
      </label>
      <label className="bug-field">
        <span className="l">Заголовок</span>
        <input value={v.title} disabled={disabled} placeholder="Что проверяем — одной строкой"
          data-testid="tc-title" onChange={(e) => set({ title: e.target.value })} />
      </label>
      <label className="bug-field">
        <span className="l">Предусловие</span>
        <textarea value={v.precondition} disabled={disabled} placeholder="Состояние ДО первого шага (данные, вход, доступ)"
          data-testid="tc-pre" onChange={(e) => set({ precondition: e.target.value })} />
      </label>
      <label className="bug-field">
        <span className="l">Шаги</span>
        <textarea value={v.steps} disabled={disabled} placeholder="1. … 2. … 3. … (одно действие на шаг, с данными)"
          data-testid="tc-steps" onChange={(e) => set({ steps: e.target.value })} />
      </label>
      <label className="bug-field">
        <span className="l">Ожидаемый результат</span>
        <textarea value={v.expected} disabled={disabled} placeholder="Что конкретно видно / меняется (число, текст, состояние)"
          data-testid="tc-expected" onChange={(e) => set({ expected: e.target.value })} />
      </label>
      <label className="bug-field">
        <span className="l">Постусловие</span>
        <input value={v.postcondition} disabled={disabled} placeholder="Что осталось в системе после (данные, сессия)"
          data-testid="tc-post" onChange={(e) => set({ postcondition: e.target.value })} />
      </label>
    </div>
  );
}
